import { Space, Typography, Layout, Row, Col } from "antd";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import logo1 from "../../assets/uni.png";
import logo2 from "../../assets/dipmed.png";
import logo3 from "../../assets/cuore.png";
import logo4 from "../../assets/sic_campania.png";
import logo5 from "../../assets/ospedale.png";
import logo6 from "../../assets/ordine_medici.png";
import { routes } from "../../routes";
import "./../../styles/CustomFooter.css";

const { Text } = Typography;
const { Footer } = Layout;

const CustomFooter = () => {
  const currentYear = new Date().getFullYear();

  const handleOkkavClick = () => {
    window.open("https://www.okkav.it", "_blank", "noopener,noreferrer");
  };

  // Componente helper per i loghi partner
  const PartnerLogo = ({ src, alt }: { src: string; alt: string }) => (
    <img
      src={src}
      alt={alt}
      className="partner-logo"
      style={{
        width: "auto",
        transition: "opacity 0.2s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = "0.7";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = "1";
      }}
    />
  );

  // Array di loghi partner (3 sinistra, 3 destra)
  const partnerLogosLeft = [
    { src: logo1, alt: "Università degli Studi di Salerno" },
    { src: logo2, alt: "Dipartimento di Medicina" },
    { src: logo3, alt: "Cuore" },
  ];
  const partnerLogosRight = [
    { src: logo4, alt: "SIC Campania" },
    { src: logo5, alt: "Ospedale" },
    { src: logo6, alt: "Ordine dei Medici" },
  ];

  return (
    <Footer
      style={{
        textAlign: "center",
        padding: "6px 5px",
        position: "sticky",
        bottom: 0,
      }}
      className="custom-footer"
    >
      <Row
        align="middle"
        justify="center"
        gutter={[16, 16]}
        style={{ width: "100%" }}
      >
        {/* Loghi partner - Desktop: sinistra, Mobile: prima riga */}
        <Col
          xs={24}
          md={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "8px",
          }}
          className="partner-logos-col"
        >
          <Space size={40} wrap>
            {partnerLogosLeft.map((item, index) => (
              <PartnerLogo key={index} src={item.src} alt={item.alt} />
            ))}
          </Space>
        </Col>

        {/* Titolo e informazioni - Desktop: centro, Mobile: seconda riga */}
        <Col xs={24} md={12} style={{ textAlign: "center" }}>
          <Text
            strong
            style={{ fontSize: "14px", display: "block", marginBottom: "4px" }}
          >
            Core Rare
          </Text>

          {/* Informazioni università */}
          <div
            style={{
              fontSize: "11px",
              lineHeight: "1.3",
              color: "#666",
              marginBottom: "6px",
            }}
          >
            <div>
              ©{currentYear} Università degli Studi di Salerno – Dipartimento di
              Medicina, Chirurgia e Odontoiatria – Scuola Medica Salernitana
            </div>
            <div>Via S. Allende, 84081 Baronissi (SA) – P.IVA 00851300657</div>
            <div>
              Piattaforma sviluppata e concessa in licenza da{" "}
              <Text
                strong
                style={{
                  color: "#262626",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                }}
                onClick={handleOkkavClick}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#1890ff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#262626";
                }}
              >
                <img
                  src={logo}
                  alt="Okkav"
                  style={{
                    height: "19px",
                    width: "auto",
                    paddingRight: "3px",
                    alignSelf: "center",
                    objectFit: "contain",
                  }}
                />
                Okkav SRL
              </Text>{" "}
              – Via Gen. Armando Diaz, 47 – 84122 Salerno (SA) – Cap. Soc. €
              10.500 i.v. – P.IVA 06059980653
            </div>
          </div>

          {/* Link footer */}
          <div style={{ fontSize: "10px", color: "#999" }}>
            <Link
              to={routes.PRIVACY_POLICY}
              style={{
                color: "#999",
                textDecoration: "none",
                marginRight: "8px",
              }}
            >
              Privacy Policy
            </Link>
            <span style={{ margin: "0 4px" }}>|</span>
            <Link
              to={routes.COOKIE_POLICY}
              style={{
                color: "#999",
                textDecoration: "none",
                marginRight: "8px",
              }}
            >
              Cookie Policy
            </Link>
            <span style={{ margin: "0 4px" }}>|</span>
            <Link
              to={routes.TERMS_AND_CONDITIONS}
              style={{ color: "#999", textDecoration: "none" }}
            >
              Termini e Condizioni
            </Link>
          </div>
        </Col>

        {/* Loghi partner destra - Desktop: destra, Mobile: terza riga */}
        <Col
          xs={24}
          md={6}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "8px",
          }}
          className="partner-logos-col partner-logos-col-right"
        >
          <Space size={8} wrap>
            {partnerLogosRight.map((item, index) => (
              <PartnerLogo key={index} src={item.src} alt={item.alt} />
            ))}
          </Space>
        </Col>
      </Row>
    </Footer>
  );
};

export default CustomFooter;
